import Vue from "vue";
import Router, { Route } from "vue-router";

import Home          from "./pages/Home.vue";
import Intro         from "./pages/Intro.vue";
import TermsOfUse    from "./pages/TermsOfUse.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import Features      from "./pages/Features.vue";
import Manual        from "./pages/Manual.vue";
import Notice        from "./pages/Notice.vue";
import NoticeDetail  from "./pages/NoticeDetail.vue";
import Payment       from "./pages/Payment.vue";
import ServiceCenter from "./pages/ServiceCenter.vue";

Vue.use(Router);

const router : Router = new Router({
    mode: "hash",
    routes: [
        /**
         * home
         */
        {
            path: "/",
            name: "home",
            component: Home,
            meta: { title : '호두앱 | 스마트워크 & 라이프, 멀티 플랫폼' }
        },
        /**
         * home intro
         */
        {
            path: "/intro",
            name: "intro",
            component: Intro,
            meta: { title : '호두앱 | 호두란?' }
        },
        /**
         * 이용약관
         */
        {
            path: "/termsOfUse",
            name: "TermsOfUse",
            component: TermsOfUse,
            meta: { title : '이용약관 | 호두앱' }
        },
        /**
         * 개인정보 취급방침
         */
        {
            path: "/privacyPolicy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
            meta: { title : '개인정보 취급방침 | 호두앱' }
        },
        /**
         * 주요기능
         */
        {
            path: "/features",
            name: "features",
            component: Features,
            meta: { title : '달력 | 주요기능' }
        },
        /**
         * 매뉴얼
         */
        {
            path: "/manual",
            name: "manual",
            component: Manual,
            meta: { title : '달력 | 매뉴얼' }
        },
        /**
         * 호두 공지사항
         */
        {
            path: "/notice",
            name: "notice",
            component: Notice,
            meta: { title : '공지사항 | 호두앱' }
        },
        /**
         * 호두 공지사항 조회
         */
        {
            path: "/notice/:noti_uid",
            name: "notice_detail",
            component: NoticeDetail,
            meta: { title : '공지사항 | 호두앱' },
            props: true
        },
        /**
         * 요금 안내
         */
        {
            path: "/payment",
            name: "payment",
            component: Payment,
            meta: { title : '요금안내 | 호두앱' },
            props: true
        },
        /**
         * 고객센터
         */
        {
            path: "/serviceCenter",
            name: "service_center",
            component: ServiceCenter,
            meta: { title : 'Q&A | 고객센터' }
        }
    ]
});

/**
 * 타이틀 설정 & 스크롤 맨 위로
 */
router.beforeEach((to : Route, from : Route, next : any) => {
    document.title = to.meta.title;
    window.scrollTo(0, 0);
    next();
});

export default router;